const map = {
	"./-impressum.svg": 1269,
	"./appstore-de.svg": 4069,
	"./appstore-en.svg": 6797,
	"./back.svg": 4002,
	"./bigstar.svg": 6787,
	"./bus-tram.svg": 4388,
	"./bus.svg": 7015,
	"./cable.svg": 3454,
	"./capacity1.svg": 4204,
	"./capacity2.svg": 3231,
	"./capacity3.svg": 9502,
	"./check.svg": 6729,
	"./default.svg": 3510,
	"./delete.svg": 154,
	"./favourites-add.svg": 1797,
	"./favourites-selected.svg": 1183,
	"./favourites.svg": 1283,
	"./impressum-selected.svg": 9014,
	"./impressum.svg": 4196,
	"./info.svg": 9339,
	"./input-delete.svg": 8843,
	"./input-search.svg": 9138,
	"./location.svg": 2254,
	"./mountains.svg": 1773,
	"./nearby.svg": 7466,
	"./next.svg": 484,
	"./rail-ld.svg": 456,
	"./rail-sd.svg": 3645,
	"./sbb.svg": 174,
	"./search.svg": 1599,
	"./ship.svg": 7345,
	"./spinner.svg": 3126,
	"./tram.svg": 1327,
	"./unhappyCloud.svg": 595,
	"./unhappyPin.svg": 69,
	"./unhappySmiley.svg": 2253,
	"./walking.svg": 8740,
	"./waves.svg": 8227
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;